import { CertificationDetailOverviewTableQuery } from './CertificationDetailOverviewTable.codegen'
import { t } from '@lingui/macro'

export const prepareCertificationDetailExport = (
  data: NonNullable<
    NonNullable<CertificationDetailOverviewTableQuery>['analytics']['certifications']['certificationEnrolments']
  >['items']
) =>
  data.map((row) => {
    const { user } = row

    return {
      [t`Display name`]: user.display_name,
      [t`Email`]: user.email,
      [t`First name`]: user.first_name,
      [t`Last name`]: user.last_name,
      [t`Position`]: user.position,
      [t`Employee ID`]: user.employee_id,
      [t`Area`]: user.area,
      [t`Location`]: user.location,
      [t`Department`]: user.department,
      [t`Custom 1`]: user.custom_1,
      [t`Custom 2`]: user.custom_2,
      [t`Custom 3`]: user.custom_3,
      [t`Account name`]: user.account_name,
      [t`Last active at`]: user.last_activity_at,
      [t`User archived at`]: user.deleted_at,
      [t`Manager ID`]: user.manager?.id,
      [t`Manager email`]: user.manager?.email,
      [t`Manager name`]: user.manager?.display_name,
      [t`Status`]: row.status,
      [t`Certification`]: row.certification.name,
      [t`Created at`]: row.created_at,
      [t`Started at`]: row.started_at,
      [t`Target date`]: row.target_date,
      [t`Completed at`]: row.completed_at,
      [t`Expires at`]: row.expires_at,
      [t`Shared at`]: row.shared_at,
      [t`Progress`]: row.progress,
      [t`Enrolment deleted at`]: row.deleted_at
    }
  })
